import SingleFilter from 'components/FilterPopover/SingleFilter';
import AppStoreContext from 'contexts/AppStoreContext';
import Immutable from 'immutable';
import React, { useContext } from 'react';
import { RFIQuery } from 'records/RFIQuery';
import { useTranslator } from '@bluebeam/react-i18n';

interface Props {
  rfiQuery: RFIQuery;
  updateRFIQuery: (nextRFIQuery: RFIQuery) => void;
}

const OverdueItemsCheckbox: React.FC<Props> = (props: Props) => {
  const { rfiQuery, updateRFIQuery } = props;
  const { state: appState } = useContext(AppStoreContext);
  const { rfis } = appState;
  const { translate } = useTranslator(['filters']);

  const now = Date.now();

  const overdueRFIs = rfis.filter(
    (rfi) => rfi.duedate === 0 || rfi.duedate < now
  );

  /* Handlers */
  function onCheckboxChange(isChecked: boolean) {
    const nextRFIQuery = isChecked
      ? rfiQuery.update('overdue', () => Immutable.Set([Date.now()]))
      : rfiQuery.delete('overdue');

    updateRFIQuery(nextRFIQuery);
  }

  return (
    <SingleFilter
      text={translate('filters:overdueItems')}
      checked={rfiQuery.overdue.size > 0}
      onChange={onCheckboxChange}
      disabled={overdueRFIs.size === 0}
    />
  );
};

export default OverdueItemsCheckbox;
